<template>
  <div class="w-full height-100">
    <el-dialog title="" :visible.sync="addRolePopup" width="30%">
      <template slot="title">
        <h3 class="fsize16 Add mb-0 Products text-white" v-if="!editbox">
          Add Role
        </h3>
        <h3 class="fsize16 Add mb-0 Products text-white" v-if="editbox">
          Update Role
        </h3>
      </template>
      <div>
        <div class="">
          <div class="relative">
            <small class="fsize12 bg-white text-dark">Role</small>
            <el-input
              v-model="name"
              @change="closeInvalidName"
              maxlength="50"
              placeholder="Enter..."
              class="rounded-xl mt-2"
            />
            <p v-if="invalidName">invalid Name</p>
          </div>
          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark">Modules</small>
            <el-select
              multiple
              v-model="selectedModules"
              placeholder="Select"
              popper-class="z-index-option"
            >
              <el-option
                v-for="(module, index) in allModules"
                :key="index"
                :label="module"
                :value="module"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex justify-center">
          <vs-button
            variant="primary"
            :disabled="updateSubmitDisable"
            class="mt-8 px-8 py-3 w-full rounded-lg"
            @click="addRole"
            >Submit</vs-button
          >
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Role Management
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top bg-white p-6">
      <div class="flex mt-4">
        <div class="w-10/12 relative">
          <el-input
            placeholder="Search"
            maxlength="50"
            v-model="search"
            @input="getRoles"
            class="w-full"
          ></el-input>
          <div class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-0">
            <feather-icon
              icon="SearchIcon"
              @click="getRoles"
              SvgClasses="w-4 h-4"
            />
          </div>
        </div>
        <div class="w-2/12 flex justify-end mb-4" @click="popupOpen">
          <vs-button type="primary" class="bg-primary rounded-lg px-10 py-3"
            >Add Role
          </vs-button>
        </div>
      </div>

      <div>
        <el-table
          :data="roles"
          border
          style="width: 100%"
          class="table-responsive mt-4 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <el-table-column prop="name" label="Roles" min-width="250px">
          </el-table-column>

          <el-table-column prop="modules" label="Modules" min-width="250px">
            <template v-slot="{ row }">
              <div class="flex gap-2 flex-wrap">
                <ol v-for="(module, index) in row.modules" :key="index">
                  <li>{{ module }}</li>
                </ol>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="Actions" min-width="40px">
            <template v-slot="{ row }">
              <div class="flex gap-1 items-center">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="editRole(row)"
                />
                <feather-icon
                  @click="removeRole(row._id)"
                  icon="TrashIcon"
                  svgClasses="w-4 h-4 text-danger"
                  class="cursor-pointer"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            @current-change="
              (value) => {
                currentPage = value;
                getRoles();
              }
            "
            layout="prev,pager,next"
            :per-size="10"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      // editbox to know when edit dialog is open
      validateModules: "",
      validateName: "",
      editbox: false,
      invalidName: false,
      currentPage: 1,
      search: "",
      pageCount: 0,
      addRolePopup: false,
      roles: [],
      name: "",
      selectedModules: [],
      selectedRole: "",
      addedExtensions: [],
      modules: [
        // "Performance",
        // "Payment Gateway",
        // "Domain",
        // "Notification",
        // "Email Templates",
        // "SMS Templates",
        // "Version",
        // "Admin Management",
        // "Error Management",
        // "Google Analytics",
        // "Role Management",
        // "Contact Us",
        // "Marcom",
        // "Branding",
        // "Landing Page",
        // "Builder",
        // "Studio",
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    popupOpen() {
      this.editbox = false;
      this.addRolePopup = true;
    },
    async getRoles() {
      let payload = {
        pagination: true,
      };
      let offset = 0;
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }
      const { data } = await this.$store.dispatch("admin/getRoles", payload);
      this.roles = data.data;
      this.pageCount = data.count;
    },
    closeInvalidName() {
      this.invalidName = false;
    },
    async addRole() {
      try {
        if (this.name.trim()) {
          let payload = {
            modules: this.selectedModules,
          };
          if (this.selectedRole) {
            Object.assign(payload, { roleId: this.selectedRole });
          }
          if (this.name.trim() != "") {
            Object.assign(payload, { name: this.name });
          }
          await this.$store.dispatch("admin/addRole", payload);
          this.addRolePopup = false;
          await this.getRoles();
        } else {
          this.invalidName = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async removeRole(id) {
      this.$swal({
        icon: "info",
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.$store.dispatch("admin/removeRole", { roleId: id });
          await this.getRoles();
        }
      });
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    editRole(data) {
      this.name = data.name;
      this.selectedRole = data._id;
      this.selectedModules = data.modules;
      this.addRolePopup = true;
      this.editbox = true;
      // made for when updating sumbit button should be disable if not changes made on imptu
      this.validateName = data.name;
      this.validateModules = data.modules;
    },

    async getAddedExtension() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      const { data } = await this.$store.dispatch(
        "Extensions/getExtensionRequest",
        payload
      );

      this.addedExtensions = data.filter((x) => x.status == "Active");
      this.addedExtensions.forEach((element) => {
        this.modules.push(element.extensionId.name);
      });
      this.$store.commit("admin/SET_ALL_MODULES", [
        ...new Set([...this.allModules, ...this.modules]),
      ]);
    },
  },

  watch: {
    addRolePopup(newValue) {
      if (!newValue) {
        this.name = "";
        this.selectedModules = [];
        this.selectedRole = "";
      }
    },
  },

  computed: {
    ...mapState("admin", ["userModules", "allModules"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("AdminPages", ["customPages"]),
    // check in update dialog if changes made in input and then sumbit button enable
    updateSubmitDisable() {
      if (this.editbox == true) {
        if (
          this.editbox == true &&
          this.validateName == this.name &&
          JSON.stringify(this.validateModules) ==
            JSON.stringify(this.selectedModules)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.name != "" && this.selectedModules != []) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  async mounted() {
    await this.$store.dispatch("AdminPages/GET");
    await this.getRoles();
    await this.getAddedExtension();
    this.customPages.forEach((element) => {
      this.modules.push(element.title);
    });
    // this.modules = [...this.allModules];
    // this.$store.commit("admin/SET_ALL_MODULES", this.modules);
    this.$store.commit("admin/SET_ALL_MODULES", [
      ...new Set([...this.allModules, ...this.modules]),
    ]);
  },
};
</script>
